"use client";
import React from "react";
import { Hero } from "app/components/hero";
import { HeroButtons } from "app/components/views/home/heroButtons";
import CiscoHyperflexBanner from "public/cisco-hyperflex/cisco-hyperflex-banner.webp";
import ciscoHyperflexTopology from "public/cisco-hyperflex/cisco-hyperflex-topology.webp";
import CiscoHyperflexPricing from "./components/ciscohyperflexPricing";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { AspectRatio, Flex } from "@chakra-ui/react";
import Image from "next/image";
import HardwareSoftware from "./components/hardwareSoftware";
import GettingStarted from "./components/gettingStarted";
import AccordionList from "app/components/shared/AccordionList";
import { CISCO_HYPERFLEX_FAQ_LIST } from "./components/constants";
import CustomCarousel from "app/components/shared/CustomCarousel";
import Certificates from "app/components/views/home/Certificates";
import TalkToUs from "app/components/shared/talkToUs";

const CiscoHyperflexPage = () => {
  return (
    <>
      <Hero
        title="Cisco HyperFlex"
        description={[
          "CloudMyLab Offers a Fully Built Cisco HyperFlex On-demand Lab Infrastructure with real hardware, latest software, and licensing.",
          "Cisco HyperFlex is the State of the art Hyper-Converged Solution. The Hyperflex HX Data Platform is a high-performance, distributed file system that supports multiple hypervisors with a wide range of enterprise-grade data management and optimization services.",
        ]}
        image={CiscoHyperflexBanner}
        points={[
          "Our Labs has been designed with a fairly open topology that can be purposed for any POC or Certification Labs",
          "We currently offer 1 Fully Built PODS at this and Labs can be reserved in blocks of 2 Days",
        ]}
      >
        <HeroButtons Pricing />
      </Hero>
      <CiscoHyperflexPricing />
      <SectionDivider label="Cisco HyperFlex Topology" />
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        mt={5}
        mb={5}
        data-cy="section-topology"
      >
        <Flex
          width={{ base: "full", md: "700px", lg: "800px" }}
          justifyContent="center"
          alignItems={"center"}
        >
          <AspectRatio
            width={"full"}
            ratio={8 / 6}
            position={"relative"}
            border={"1px solid #aaa"}
          >
            <Image
              alt={"Cisco Hyperflex Topology"}
              title={"Cisco Hyperflex Topology"}
              src={ciscoHyperflexTopology}
              sizes="100vw"
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
        </Flex>
      </Flex>
      <HardwareSoftware />
      <GettingStarted />
      <SectionDivider label="Some FAQs Before You Buy" />
      <AccordionList items={CISCO_HYPERFLEX_FAQ_LIST} />
      <Certificates />
      <CustomCarousel />
      <TalkToUs />
    </>
  );
};

export default CiscoHyperflexPage;
